import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent } from "@mui/material";
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import Loading from "./Loading";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import React, { useState, useEffect } from "react";
import ReportCriteria from "./partials/admincenter/ReportCriteria";
import AdminTabs from "./partials/admincenter/AdminTabs";
import ResponsiveRectangle from "./partials/skeletons/ResponsiveRectangle";
import DataReportTable from "./partials/admincenter/ReportDataReportTable";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullscreenExit, SettingsPowerRounded } from "@mui/icons-material";
import { fetchReportProducts } from "../reducers/reference_reportproduct";
import ReportContainer from "./partials/admincenter/ReportContainer";
import { fetchViewInstances, selectViewInstanceById } from '../reducers/reuseable_vi';




const AdminCenterReports = () => {
    const { mainUser: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const DataReportStatus = useSelector(state => state.datareports.status)
    const ReportProductsStatus = useSelector(state => state.reportproducts.status)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userIsAdmin = (currentUser && (currentUser.IsAdmin === true))
    const viewInstanceLegend = useSelector(state => selectViewInstanceById(state,'ReportLegend'))

    useEffect(() => {
        if (userIsAdmin === false) {
            navigate('/home')
            //} else {
                //if (ReportProductsStatus === 'idle') {
                    //dispatch(fetchReportProducts({ AuthToken: currentUser.AuthToken }))
                //}
                //if (!callVI && (!viewInstance || !viewInstance.AdminCenterPage) && currentUser && currentUser.AuthToken) {
                    //setCallVI(true);
                    //dispatch(getViewInstance('F68B82A2-D122-4A05-B11D-BD91A2A52DC3', currentUser.AuthToken))
                //}
        }
    }, [userIsAdmin, navigate])

    useEffect(() => {
        if (( userIsAdmin === true ) &&
            currentUser &&
            (ReportProductsStatus === 'idle'))
        {
            dispatch(fetchReportProducts({ AuthToken: currentUser.AuthToken }))
        }
    }, [userIsAdmin, currentUser, dispatch, ReportProductsStatus])

    /*if (!currentUser) {
      return <Navigate to="/login" />;
    }*/
    useEffect(() => {
        //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
        if ((!viewInstanceLegend || !viewInstanceLegend.LegendsVI)) {
          dispatch(fetchViewInstances({authToken: currentUser.AuthToken, VIGuid:'CAFE4E0B-EDD4-466F-A9A9-73833821531F', VIName:"ReportLegend"}))
        }
      }, [location.pathname])
      
    useEffect(() => { }, [dispatch, DataReportStatus])

    useEffect(() => {
     
        if ( ( userIsAdmin === true ) &&
            currentUser &&
            !callVI &&
            (!viewInstance || !viewInstance.AdminCenterPage) ) 
        {
            setCallVI(true);
            dispatch(getViewInstance('F68B82A2-D122-4A05-B11D-BD91A2A52DC3', currentUser.AuthToken))
        }
    }, [userIsAdmin, currentUser, setCallVI, viewInstance, dispatch, location.pathname])

    //if (!callVI && (!viewInstance || !viewInstance.AdminCenterPage) && currentUser && currentUser.AuthToken) {
        //setCallVI(true);
        //dispatch(getViewInstance('F68B82A2-D122-4A05-B11D-BD91A2A52DC3', currentUser.AuthToken))
    //}

    const handleAdminClick = () => {
       
        navigate({ pathname: '/adminreport', search: createSearchParams({ vi: 'BFAB12B2-CD8A-4E9A-B73C-4B3E9C783BA7' }).toString() })
    }

    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }

    return (
        <div>
            <Header />

            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                        <Paper elevation={1} style={{ marginTop: '150px', padding: '40px' }}>
                            <AdminTabs page="REPORTS" />
                        </Paper>
                    </motion.div>
                </Grid>
                <Grid item xs={12}>
                    <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                        <Paper elevation={1} style={{ padding: '40px' }}>
                            {viewInstance && viewInstance.AdminCenterPage && ReportProductsStatus === 'success' ?
                                (
                                    <ReportCriteria ReportTab={viewInstance.AdminCenterPage.ReportTab} />
                                ) : (<ResponsiveRectangle height="40" />)
                            }
                        </Paper>
                    </motion.div>
                </Grid>

                <Grid item xs={12}>
                    <motion.div variants={motionVariants} initial="hidden" whileInView="show" style={{ height: '100%' }}>
                        <Paper elevation={1} style={{ padding: '40px'}}>
                        {viewInstance && viewInstance.AdminCenterPage && ReportProductsStatus === 'success' ?
                                (
                            <ReportContainer />
                            ) : (<ResponsiveRectangle height="40" />)
                            }
                        </Paper>
                    </motion.div>
                </Grid>

            </Grid>

            <Footer />
        </div >
    )

};

export default AdminCenterReports;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */